import { createSlice } from '@reduxjs/toolkit';

import {
  unlinkWalletAccount,
  updateWalletAccount,
} from '@pages/organizer/Finance/components/tabs/Wallet/store/wallet-actions';

import type { WalletPaymentAccountType } from '@pages/organizer/Finance/components/tabs/Wallet/store/wallet-types';
import type { WalletSliceState } from '@pages/organizer/Finance/components/tabs/Wallet/store/wallet-types';
import type { PayloadAction } from '@reduxjs/toolkit';

const initialState: WalletSliceState = {
  accountList: { data: [], meta: { net_balance: 0 } },
};

export const walletSlice = createSlice({
  name: 'walletSlice',
  initialState,
  reducers: {
    setWalletAccounts: (
      state,
      action: PayloadAction<{ data: WalletPaymentAccountType[]; meta: { net_balance: number } }>,
    ) => {
      state.accountList = action.payload;
    },
    changeWalletAccountsNetBalance: (
      state,
      action: PayloadAction<{ data: WalletPaymentAccountType[]; meta: { net_balance: number } }>,
    ) => {
      state.accountList.meta.net_balance = action.payload?.meta?.net_balance || 0;
    },
    resetWalletStore: () => {
      return { ...initialState };
    },
  },
  extraReducers: ({ addCase }) => {
    addCase(updateWalletAccount.fulfilled, (state, { payload }) => {
      if (payload) {
        state.accountList.data = state.accountList?.data?.map((item) => {
          if (item.id === payload.id) {
            return { ...item, ...payload };
          }
          return item;
        });
      }
    });
    addCase(unlinkWalletAccount.fulfilled, (state, { payload }) => {
      state.accountList.data = state.accountList.data.filter(
        (item: WalletPaymentAccountType) => item.id !== payload,
      );
    });
  },
});

export const { resetWalletStore, setWalletAccounts, changeWalletAccountsNetBalance } = walletSlice.actions;
export default walletSlice.reducer;
